import { MultiSelect } from 'primereact/multiselect';
import { ReactElement, useMemo } from 'react';

import { SortedMultiSelectProps } from './SortedMultiSelect.types';

const compare = (a: string | number, b: string | number): number => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;

  let aValue = a;
  let bValue = b;
  if (typeof a === 'string' && typeof b === 'string') {
    const aNumber = Number(a);
    const bNumber = Number(b);
    if (Number.isFinite(aNumber) && Number.isFinite(bNumber)) {
      return aNumber - bNumber;
    } else {
      aValue = a.toLowerCase();
      bValue = b.toLowerCase();
    }
  }

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return aValue - bValue;
  }

  return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
};

const SortedMultiSelect = <T extends string | number>({
  options = [],
  sortBy,
  ...props
}: SortedMultiSelectProps<T>): ReactElement => {
  const sortedOptions = useMemo<T[]>(() => {
    if (!Array.isArray(options)) {
      return [];
    }

    return [...options].sort((first, second) => {
      const [firstValue, secondValue] = sortBy
        ? [first[sortBy], second[sortBy]]
        : [first, second];

      return compare(firstValue, secondValue);
    });
  }, [options, options?.length, sortBy]);

  return <MultiSelect {...props} options={sortedOptions} />;
};

export default SortedMultiSelect;
